export default __webpack_public_path__ + "static/media/chevron-down-solid.a4f409dd.svg";